var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"home"},[_c('ContainerView',[_c('MainTitle',{staticClass:"text-center mb-12",attrs:{"tag":'h1'}},[_c('i',{staticClass:"fas fa-users"}),_vm._v(" Quem somos ")]),_c('AboutArticles'),_c('hr',{staticClass:"w-2/3 mx-auto my-12 border-gray"}),_c('AboutCards')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }